import { AnimatePresence, motion } from 'framer-motion';

import { TaggedDocuments } from './tagged-documents';
import { PreviousThreads } from '../previous-threads/previous-threads';

interface QuestionSidebarProps {
  taggedDocuments: { doc_id: string; file_name: string }[];
}

export function QuestionSidebar({ taggedDocuments }: QuestionSidebarProps) {
  const taggedItemsExist = taggedDocuments.length > 0;

  return (
    <div className="flex h-full w-56 min-w-56 flex-col border-r">
      <AnimatePresence>
        {taggedItemsExist && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: '33.333%', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="flex flex-col border-b border-gray-100"
          >
            <div className="border-b border-gray-100 bg-gray-50/50 px-4 py-3">
              <h3 className="text-sm font-medium text-gray-800">Tagged Documents</h3>
              <p className="mt-0.5 text-xs text-gray-500">
                {taggedDocuments.length} document{taggedDocuments.length !== 1 ? 's' : ''}
              </p>
            </div>
            <div className="flex-1 overflow-hidden p-4">
              <TaggedDocuments taggedDocuments={taggedDocuments} />
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        layout
        style={{ height: taggedItemsExist ? '66.666%' : '100%' }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
        className="flex flex-col"
      >
        <div className="border-b border-gray-100 bg-gray-50/50 px-4 py-3">
          <h3 className="text-sm font-medium text-gray-800">Question History</h3>
        </div>
        <div className="flex-1 overflow-auto">
          <PreviousThreads />
        </div>
      </motion.div>
    </div>
  );
}
